var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 316,
    viewBox: "0 0 260 316",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.391 357.859H9.21094C-2.50316 357.859 -12 348.363 -12 336.648V31.2109C-12 19.4968 -2.50316 10 9.21094 10H228.391C240.105 10 249.602 19.4968 249.602 31.2109V336.648C249.602 348.363 240.105 357.859 228.391 357.859Z",
    stroke: "#2B195B",
    strokeWidth: 20,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.828 38.2812H171.271C169.146 47.2004 161.13 53.8359 151.56 53.8359H86.0412C76.4708 53.8359 68.4552 47.2004 66.3299 38.2812H65.7734H16.2812V329.578H221.32V38.2812H171.828Z",
    fill: "#EAE8EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M157.688 113.934H132.941V89.1875H104.66V113.934H79.9141V142.215H104.66V166.961H132.941V142.215H157.688V113.934Z",
    stroke: "#2B195B",
    strokeWidth: 16,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0547 202.312H51.6328V230.594H94.0547V202.312Z",
    stroke: "#2B195B",
    strokeWidth: 16,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.406 230.594H185.969",
    stroke: "#2B195B",
    strokeWidth: 16,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.406 202.312H185.969",
    stroke: "#2B195B",
    strokeWidth: 16,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0547 265.945H51.6328V294.227H94.0547V265.945Z",
    stroke: "#2B195B",
    strokeWidth: 16,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.406 294.227H185.969",
    stroke: "#2B195B",
    strokeWidth: 16,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M129.406 265.945H185.969",
    stroke: "#2B195B",
    strokeWidth: 16,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M151.56 53.8359H86.0412C74.8475 53.8359 65.7734 44.7619 65.7734 33.5682V10H171.828V33.5682C171.828 44.7619 162.753 53.8359 151.56 53.8359Z",
    stroke: "#2B195B",
    strokeWidth: 20,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHc);
export default __webpack_public_path__ + "static/media/hc.77723c9f161c5f4da133dde18d180f37.svg";
export { ForwardRef as ReactComponent };